export const ACTION_SLUG_DASHBOARD_CAPTUREDUNITS_FILTER = 'dashboard-capturedunits-filter';
export const ACTION_SLUG_DASHBOARD_INVDETAILS_FILTER = 'dashboard-invdetails-filter';
export const ACTION_SLUG_DASHBOARD_MAINTOTALACTIVE = 'dashboard-maintotalactive';
export const ACTION_SLUG_DASHBOARD_SERVICEINDICATOR = 'dashboard-serviceindicator';
export const ACTION_SLUG_DASHBOARD_TOTALACTIVE = 'dashboard-totalactive';
export const ACTION_SLUG_DASHBOARD_VDPANALYTICS = 'dashboard-vdpanalytics';
export const ACTION_SLUG_DASHBOARD_VEHCUTOUT = 'dashboard-vehcutout';
export const ACTION_SLUG_DASHBOARD_INVENTORYFILE_LASTUPDATE = 'dashboard-inventoryfile-lastupdate';

export const ACTION_SLUG_DEALERPROFILE_BODYSTYLESTABLE = 'dealerprofile-bodystylestable';
export const ACTION_SLUG_DEALERPROFILE_DMSCONFIG = 'dealerprofile-dmsconfig';
export const ACTION_SLUG_DEALERPROFILE_IMPORT_REPORTDETAILS_FILTER =
  'dealerprofile-import-reportdetails-filter';
export const ACTION_SLUG_DEALERPROFILE_LOWPHOTS_NOTIFI_FILTER = 'dealerprofile-lowphots-notifi-filter';
export const ACTION_SLUG_DEALERPROFILE_PHOTOREPORT_DETAILS = 'dealerprofile-photoreport-details';
export const ACTION_SLUG_DEALERPROFILE_SALESREPS = 'dealerprofile-salesreps';
export const ACTION_SLUG_DEALERPROFILE_EDITDMSID = 'dealerprofile-editdmsid';
export const ACTION_SLUG_DEALERPROFILE_DEALERSHIP_CANCELLATION = 'dealerprofile-dealership-cancellation';
export const ACTION_SLUG_DEALERPROFILE_DEALER_LOGS = 'dealerprofile-dealer-logs';

export const ACTION_SLUG_INVENTORY_INVDETAILINFO = 'inventory-invdetailinfo';
export const ACTION_SLUG_INVENTORY_SEARCHINV = 'inventory-searchinv';
export const ACTION_SLUG_INVENTORY_DEALER_RATINGFILE = 'inventory-dealer-ratingfile';
export const ACTION_SLUG_INVENTORY_GALLERY_DROPZONE_DELETE = 'inventory-gallery-dropzone-delete';
export const ACTION_SLUG_INVENTORY_NOTE_MODAL = 'inventory-note-modal';
export const ACTION_SLUG_INVENTORY_ADDENDUM_MODAL = 'inventory-addendum-modal';
export const ACTION_SLUG_INVENTORY_SEND_PHOTO_REPORT = 'inventory-send-photo-report';
export const ACTION_SLUG_INVENTORY_ACTION_GALLERY = 'inventory-action-gallery';
export const ACTION_SLUG_INVENTORY_ACTION_VDS_CLONE = 'inventory-action-vds-clone';
export const ACTION_SLUG_INVENTORY_ACTION_CUSTOM_COMMENT_AI = 'inventory-action-custom-comment-ai';
export const ACTION_SLUG_INVENTORY_ACTION_VDP_TRENDS = 'inventory-action-vdp-trends';
export const ACTION_SLUG_INVENTORY_ACTION_DOWNLOAD_ALL_EXPORT_PHOTOS =
  'inventory-action-download-all-export-photos';
export const ACTION_SLUG_INVENTORY_SEND_INDIVIDUAL_AGE_BUCKET_REPORT =
  'inventory-send-individual-age-bucket-report';

export const ACTION_SLUG_INVENTORY_AGE_BUCKETSWIDGET = 'inventory-age-bucketswidget';

export const ACTION_SLUG_PROMOTIONALBANNER_GALLERY_DROPZONE_DELETE =
  'promotionalbanner-gallery-dropzone-delete';
export const ACTION_SLUG_QUALITYCONTROL_GALLERY_DROPZONE_DELETE = 'qualitycontrol-gallery-dropzone-delete';
export const ACTION_SLUG_EDITFLAGS_DOWNLOADXLS = 'editflags-downloadxls';

export const ACTION_SLUG_ACCOUNTS_CHANGEPASSWORD = 'accounts-changepassword';
export const ACTION_SLUG_ACCOUNTS_DIRECTLOGIN = 'accounts-directlogin';
export const ACTION_SLUG_ACCOUNTS_EDITACESS = 'accounts-editacess';
export const ACTION_SLUG_ACCOUNTS_TEAM_PROFILE = 'accounts-team-profile';
export const ACTION_SLUG_ACCOUNTS_TEAMPROFILE_EDITORTEAM_OPTION = 'accounts-teamprofile-editorteam-option';
export const ACTION_SLUG_ACCOUNTS_DEALER_PROFILE = 'accounts-dealer-profile';
export const ACTION_SLUG_ACCOUNTS_REINVITE = 'accounts-reinvite';
export const ACTION_SLUG_ACCOUNTS_RESET2FA = 'accounts-reset2fa';
export const ACTION_SLUG_ACCOUNTS_RESETPASSWORD = 'accounts-resetpassword';
export const ACTION_SLUG_ACCOUNTS_NOTIFICATION = 'accounts-notification';
export const ACTION_SLUG_ACCOUNTS_TEAMPROFILE_DEALERLISTTABLE = 'accounts-teamprofile-dealerlisttable';
export const ACTION_SLUG_ACCOUNTS_TEAMPROFILESETTING_DEBUG = 'accounts-teamprofilesetting-debug';
export const ACTION_SLUG_ACCOUNTS_TEAMPROFILE_TEAMTABLE_DELETEACTION =
  'accounts-teamprofile-teamtable-deleteaction';
export const ACTION_SLUG_ACCOUNTS_GROUP_SEND_IMPORT_REPORT = 'accounts-group-send-import-report';
export const ACTION_SLUG_ACCOUNTS_GROUP_SEND_PHOTO_REPORT = 'accounts-group-send-photo-report';

export const ACTION_SLUG_MAVIS_DELETE = 'mavis-delete';
export const ACTION_SLUG_MAVIS_DOWNLOAD = 'mavis-download';
export const ACTION_SLUG_MAVIS_GALLERY = 'mavis-gallery';
export const ACTION_SLUG_MAVIS_NEEDASSISTANCE = 'mavis-needassistance';
export const ACTION_SLUG_MAVIS_PUBLISH = 'mavis-publish';
export const ACTION_SLUG_MAVIS_REJECTVDS = 'mavis-rejectvds';
export const ACTION_SLUG_MAVIS_REQ_MANUALCUTOUT = 'mavis-req-manualcutout';
export const ACTION_SLUG_MAVIS_CLOCKIN = 'mavis-clockin';
export const ACTION_SLUG_MAVIS_EDITORPHOTOSCOUNT = 'mavis-editorphotoscount';
export const ACTION_SLUG_MAVIS_NOTESENABLE = 'mavis-notesenable';
export const ACTION_SLUG_MAVIS_VEHEDITED_COUNT = 'mavis-vehedited-count';
export const ACTION_SLUG_MAVIS_TONE_SAVEPUBLISH = 'mavis-tone-savepublish';
export const ACTION_SLUG_MAVIS_FLAGMODAL = 'mavis-flagmodal';
export const ACTION_SLUG_MAVIS_ASSISTANCEMODAL_OTHER_OPTION = 'mavis-assistancemodal-other-option';
export const ACTION_SLUG_MAVIS_ACTION_NOT_VDS = 'mavis-action-not-vds';
export const ACTION_SLUG_MAVIS_ACTION_DELETE_SELECTED_IMAGES = 'mavis-action-delete-selected-images';
export const ACTION_SLUG_MAVIS_IMAGE_FLAG_MODAL = 'mavis-image-flag-modal';
export const ACTION_MAVIS_OTHER_OPTION_FLAG = 'mavis-other-option-for-flag';
export const ACTION_MAVIS_SHOW_SUBMIT_FOR_TRAINING_OPTION = 'mavis-show-submit-for-training-option';
export const ACTION_SLUG_MAVIS_REVIEW = 'mavis-review';

export const ACTION_SLUG_VIDEO_ASSISTANCEMODAL_OTHER_OPTION = 'video-assistancemodal-other-option';
export const ACTION_SLUG_VIDEO_DELETE = 'video-delete';
export const ACTION_SLUG_VIDEO_DOWNLOAD = 'video-download';
export const ACTION_SLUG_VIDEO_REPROCESSVIDEO = 'video-reprocessvideo';
export const ACTION_SLUG_VIDEO_WATCHVIDEO = 'video-watchvideo';
export const ACTION_SLUG_VIDEO_FLAGMODAL = 'video-flagmodal';
export const ACTION_SLUG_VIDEO_NEEDASSISTANCE = 'video-needassistance';
export const ACTION_SLUG_VIDEO_IMAGE_FLAG_MODAL = 'video-image-flag-modal';

export const ACTION_SLUG_EXPORT_GALLERY_DROPZONE_DELETE = 'export-gallery-dropzone-delete';
export const ACTION_SLUG_EXPORT_PUBLISH = 'export-publish';
export const ACTION_SLUG_EXPORT_CHANGETYPE = 'export-changetype';
export const ACTION_SLUG_EXPORT_CLEARSERVERCACHE = 'export-clearservercache';
export const ACTION_SLUG_EXPORT_DELETE = 'export-delete';
export const ACTION_SLUG_EXPORT_DEPUBLISH = 'export-depublish';
export const ACTION_SLUG_EXPORT_MASS_REPUBLISH_BUTTON = 'export-mass-republish-button';
export const ACTION_SLUG_EXPORT_VEHICLE_GALLERY = 'export-vehicle-gallery';
export const ACTION_SLUG_EXPORT_DROP_ZIP_ANYWHERE_TO_UPLOAD = 'export-drop-zip-anywhere-to-upload';

export const ACTION_SLUG_INSTA360_DELETE = 'insta360-delete';
export const ACTION_SLUG_INSTA360_DOWNLOAD = 'insta360-download';
export const ACTION_SLUG_INSTA360_FLAGMODAL = 'insta360-flagmodal';
export const ACTION_SLUG_INSTA360_IMAGE_FLAG_MODAL = 'insta360-image-flag-modal';

export const ACTION_SLUG_IMPORT_AUTOEDIT = 'import-autoedit';
export const ACTION_SLUG_IMPORT_DELETE = 'import-delete';
export const ACTION_SLUG_IMPORT_DOWNLOAD = 'import-download';
export const ACTION_SLUG_IMPORT_MERGETWOVEHICLES = 'import-mergetwovehicles';
export const ACTION_SLUG_IMPORT_MOVETO = 'import-moveto';
export const ACTION_SLUG_IMPORT_RENAME = 'import-rename';
export const ACTION_SLUG_IMPORT_SWAPVIN = 'import-swapvin';
export const ACTION_SLUG_IMPORT_SENDIMPORT_REPORT = 'import-sendimport-report';

export const ACTION_SLUG_EXPORT_ACTIONVISIBLE = 'export-actionvisible';
export const ACTION_SLUG_IMPORT_ACTIONVISIBLE = 'import-actionvisible';
export const ACTION_SLUG_INSTA360_ACTIONVISIBLE = 'insta360-actionvisible';
export const ACTION_SLUG_MAVIS_ACTIONVISIBLE = 'mavis-actionvisible';
export const ACTION_SLUG_VIDEO_ACTIONVISIBLE = 'video-actionvisible';

export const ACTION_SLUG_USERROLES_SET_ACTIONS_BY_MODULE = 'userroles-set-actions-by-module';
export const ACTION_SLUG_USERROLES_SET_MODULES = 'userroles-set-modules';
export const ACTION_SLUG_USERROLES_SET_PERMISSIONS = 'userroles-set-permissions';
export const ACTION_SLUG_USERROLES_SET_ROLES = 'userroles-set-roles';

export const ACTION_SLUG_MAVISSETTINGS_COMPOSITION_SAVE_BUTTON = 'mavissettings-composition-save-button';
export const ACTION_SLUG_MAVISSETTINGS_PRESETS_APPLY_BUTTON = 'mavissettings-presets-apply-button';
export const ACTION_SLUG_MAVISSETTINGS_UPLOAD_FRAME_NEW_USED = 'mavissettings-upload-frame-new-used';
export const ACTION_SLUG_MAVISSETTINGS_UPLOAD_FRAME_DMS_OVERLAY = 'mavissettings-upload-frame-dms-overlay';
export const ACTION_SLUG_MAVISSETTINGS_UPLOAD_FRAME_CERTIFIED_OVERLAY =
  'mavissettings-upload-frame-certified-overlay';
export const ACTION_SLUG_MAVISSETTINGS_CLEAR_ALL_BACKGROUND = 'mavissettings-clear-all-background';
export const ACTION_SLUG_MAVISSETTINGS_REMOVE_BG_ALL_EXTERIORS_INTERIORS =
  'mavissettings-remove-bg-all-exteriors-interiors';
export const ACTION_SLUG_MAVISSETTINGS_APPLY_OVERLAY_BUTTON = 'mavissettings-apply-overlay-button';
export const ACTION_SLUG_MAVISSETTINGS_APPLY_TO_ALL_BUTTON = 'mavissettings-apply-to-all-button';
export const ACTION_SLUG_MAVISSETTINGS_REPROCESS_DEALER_GRAPHIC_BUTTON =
  'mavissettings-reprocess-dealer-graphic-button';

export const ACTION_SLUG_RETROOPERATIONS_REPROCESSBG = 'retrooperations-reprocessbg';
export const ACTION_SLUG_RETROOPERATIONS_REMOVECOMPOSITIONS = 'retrooperations-removecompositions';

export const ACTION_SLUG_MAVISPRESETS_GET_ALL_PRESETS_WITH_ALL_INFO =
  'mavispresets-get-all-presets-with-all-info';

export const ACTION_SLUG_DEALERCOMPARISON_AGE_BUCKETS = 'dealercomparison-age-buckets';

export const ACTION_SLUG_INVENTORY_SEND_VDS_REPORT = 'inventory-send-vds-report';
export const ACTION_SLUG_MAVIS_SKIP_FROM_EDITING = 'mavis-skipfromediting';
export const ACTION_SLUG_INSTA360_REVIEW = 'insta360-review';
export const ACTION_SLUG_IMPORT_MASS_AUTOEDIT_BUTTON = 'import-mass-autoedit-button';
export const ACTION_SLUG_IMPORT_FLAG_AND_DOWNLOAD = 'import-flag-and-download';
export const ACTION_SLUG_IMPORT_REVIEW = 'import-review';
export const ACTION_SLUG_IMPORT_CHANGE_VEH_ROLE = 'import-change-veh-ratio';
export const ACTION_SLUG_IMPORT_NOTESENABLE = 'import-notesenable';
export const ACTION_SLUG_VIDEO_REVIEW = 'video-review';
export const ACTION_SLUG_EXT360_ACTIONVISIBLE = 'ext360-actionvisible';
export const ACTION_SLUG_EXT360_DOWNLOAD = 'ext360-download';
export const ACTION_SLUG_EXT360_DELETE = 'ext360-delete';

// #region General Settings
export const ACTION_ACTIVE_DEALER_IN_DD_LIST = 'app-global-active-inactive-dealer-in-dd-list';
export const ACTION_CHANGE_PASSWORD = 'app-global-change-password';
export const ACTION_CRON_STATS = 'app-global-cron-stats';
export const ACTION_ORDER_PROGRESS_DECALS = 'app-global-order-progress-decals';
export const ACTION_SUBMIT_FEEDBACK = 'app-global-submit-feedback';
export const ACTION_WIN_STICKER_BUY_GUIDE_ORDER = 'app-global-window-stickers-buyers-guide-order';
export const ACTION_TOGGLE_SALES_DEMO_MODE = 'app-global-toggle-sales-demo-mode';

// #region EDIT TRACKER
export const ACTION_EDIT_TRACKER_SHOW_SUBMIT_FOR_TRAINING_OPTION =
  'edittracker-show-submit-for-training-option';

// #region GLOBAL
export const ACTION_GLOBAL_AP_SETTING_MASS_RE_PUBLISH = 'global-ap-settings-mass-re-publish';
export const ACTION_GLOBAL_AP_SETTING_TOGGLE_SALES_DEMO_MODE = 'global-ap-settings-toggle-sales-demo-mode';

// #region RATIO SETTINGS
export const ACTION_SAVE_ASPECT_RATIO = 'ratio-settings-save-aspect-ratio';
export const ACTION_REPROCESS_DEALER_ALL_VEH_RATIO = 'ratio-settings-reprocess-dealer-all-vehicles-ratio';
